export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13090.fcbc3c35.jpg";